<!--
  메인 메뉴
  접속 계정 정보 팝업

  @since 2018-10-08
  @author 강정규 ( devp012 )
-->
<template>
  <div>
    <div v-if="isShowAdminInfo">
      <span class="q-tooltip animate-popup-up bs bs-q-tooltip bs-q-tooltip-default bs-q-tooltip-my-info right"
            :style="getLoginPopupPosition">
        <!--style="top: 487px; left: 165px;"-->
        <div class="my-info-group">
          <div class="my-info">
            <p class="info-id">ID : {{this.$store.state.common.common.authUser.login_id}}</p><!-- NGF -->
            <!--<p class="info-id">ID : {{$store.state.common.authenticate.authUser.id}}</p>--><!-- TAMS -->
            <!--접속시간-->
            <p class="info-time">{{$t('sm.loginInfoPopup_popup_connectedTime')}}: {{connectDateTime}}</p>
          </div>
          <div class="my-info-btn" v-if="!isGeWindow">
            <div class="my-info-btn-left">
              <q-btn @click="onClickAdmSetting" color="dark" flat="flat"
                     class="bs bs-q-btn-xs bs-q-btn-flat-type bs-q-btn-info-setup">
                <!--개인정보 설정-->
                <span class="bs-q-btn-text">{{$t('sm.loginInfoPopup_popup_setLoginInfo')}}</span>
                <q-icon class="bs-q-btn-icon bs-q-btn-icon-info-setup"/>
              </q-btn>
            </div>
            <div class="my-info-btn-right">
              <!--로그아웃-->
              <q-btn :label="this.$t('cmn.logout')" @click="onClickLogout" color="primary" outline="outline"
                     class="bs bs-q-btn-xs bs-q-btn-line"/>
            </div>
          </div>
        </div>
      </span>
    </div>

    <!-- 추가/수정 팝업-->
    <!--<AdministratorPopup ref="administratorPopup" v-if="isShowAdminInfo || isShowAdmPopup" @hide="onHideAdmPopup"/>-->
    <account-popup ref="accountPopup"
                   v-if="isShowAdminInfo || isShowAdmPopup" />
  </div>
</template>

<script>
  // utils
  import {formatDate} from '~/utils/date'

  // store helper
  import {createNamespacedHelpers} from 'vuex'

  const authenticateStore = createNamespacedHelpers('common/authenticate')
  // const adminStore = createNamespacedHelpers('system/adminSettings/administrator/administrator')

  // import AdministratorPopup from '~/pages/system/adminSettings/administratorPopup/administratorPopup'
  import myAccountSettings from '~/components/pageComponents/common/myAccountSettings'

  export default {
    name: 'login-info-popup',
    components: {
      'account-popup': myAccountSettings
      // AdministratorPopup
    },
    data () {
      return {
        isShowAdminInfo: false,
        isShowAdmPopup: false,
        connectDateTime: ''
      }
    },
    computed: {
      getLoginPopupPosition () {
        const menuCount = this.$store.state.common.common.uiData.menu.length || 0,
          top = menuCount > 0 ? menuCount * 51 + 70 + 31 + 8 : 77 // 보정

        return {
          top: `${top}px`,
          left: '165px'
        }
      },
      isGeWindow () {
        try {
          return this.$route.query.geWindow || this.$store.getters['common/authenticate/isExistGeToken']
        } catch (e) {
          return false
        }
      }
    },
    mounted () {},
    methods: {
      ...authenticateStore.mapActions([
        'logout'
      ]),
      // ...adminStore.mapActions([
      //   'getAdminDataById'
      // ]),
      show () {
        if (this.connectDateTime === '') {
          this.setLoginTime()
        }

        this.isShowAdminInfo = true
        this.isShowAdmPopup = true
      },
      hide () {
        this.isShowAdminInfo = false
      },
      setLoginTime () {
        this.connectDateTime = formatDate(this.$store.state.common.common.uiData.system.current_time, 'YYYY-MM-DD HH:mm:ss') // NGF
        // this.connectDateTime = formatDate(this.$store.state.common.authenticate.authUser.current_time, 'YYYY-MM-DD HH:mm:ss') // TAMS
      },
      async onClickAdmSetting () {
        // NGF
        // await this.getAdminDataById(this.$store.state.common.common.authUser.adm_id)
        // this.$refs.administratorPopup.show('EDT', true)
        // TAMS
        this.$refs.accountPopup.show()
      },
      onHideAdmPopup () {
        this.isShowAdmPopup = false
      },
      onClickLogout () {
        this.logout()
      }
    }
  }
</script>

<style scoped>

</style>
